import { Box, FormControlLabel, Switch, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Search, SearchIconWrapper, StyledInputBase } from "../Search";

// title and filters of the Earn pages; on small screens the filters wrap under the title
const FiltersEarn = (props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        width: "100%",
      }}
    >
      <Typography variant="h5" component="h1">
        {props.name}
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2 }}>
        {props.enableStake ? (
          <FormControlLabel
            control={
              <Switch
                size="small"
                checked={props.filterStake}
                onChange={() => props.setFilterStake(!props.filterStake)}
              />
            }
            label="Staked only"
            sx={{ mr: 0, "& .MuiFormControlLabel-label": { color: "text.secondary", fontSize: "0.9375rem" } }}
          />
        ) : null}
        {props.enableStatus ? (
          <ToggleButtonGroup
            size="small"
            exclusive
            value={props.filterStatus}
            aria-label="status"
            onChange={(e, value) => {
              if (value) props.setFilterStatus(value);
            }}
          >
            <ToggleButton value="Live" sx={{ px: 2 }}>
              Live
            </ToggleButton>
            <ToggleButton value="Finished" sx={{ px: 2 }}>
              Finished
            </ToggleButton>
          </ToggleButtonGroup>
        ) : null}
        {props.enableSearch ? (
          <Search size="small">
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              onChange={(e) => props.setFilterSearch(e.target.value)}
              size="small"
              placeholder={props.search}
            />
          </Search>
        ) : null}
      </Box>
    </Box>
  );
};

export default FiltersEarn;
